import { Route } from "react-router-dom";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import PublicRoute from "../components/auth/PublicRoute";
import { ROUTES } from "../constants/routes";
// Auth pages
import AccountSetup from "../pages/auth/AccountSetup";
import AuthAction from "../pages/auth/AuthAction";
import ConfirmEmail from "../pages/auth/ConfirmEmail";
import CreateNewPassword from "../pages/auth/CreateNewPassword";
import EmailConfirmed from "../pages/auth/EmailConfirmed";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ForgotPasswordCheckEmail from "../pages/auth/ForgotPasswordCheckEmail";
import ResetPassword from "../pages/auth/ResetPassword";
import Signin from "../pages/auth/Signin";
import Signup from "../pages/auth/Signup";

export const AuthRoutes = [
  <Route
    key="signin"
    path={ROUTES.SIGNIN}
    element={
      <PublicRoute>
        <Signin />
      </PublicRoute>
    }
  />,
  <Route
    key="signup"
    path={ROUTES.SIGNUP}
    element={
      <PublicRoute>
        <Signup />
      </PublicRoute>
    }
  />,
  <Route
    key="confirm-email"
    path={ROUTES.CONFIRM_EMAIL}
    element={
      <PublicRoute>
        <ConfirmEmail />
      </PublicRoute>
    }
  />,
  <Route
    key="auth-action"
    path={ROUTES.AUTH_ACTION}
    element={<AuthAction />}
  />,
  <Route
    key="email-confirmed"
    path={ROUTES.EMAIL_CONFIRMED}
    element={<EmailConfirmed />}
  />,
  <Route
    key="account-setup"
    path={ROUTES.ACCOUNT_SETUP}
    element={
      <ProtectedRoute>
        <AccountSetup />
      </ProtectedRoute>
    }
  />,
  <Route
    key="forgot-password"
    path={ROUTES.FORGOT_PASSWORD}
    element={
      <PublicRoute>
        <ForgotPassword />
      </PublicRoute>
    }
  />,
  <Route
    key="forgot-password-check"
    path={ROUTES.FORGOT_PASSWORD_CHECK_EMAIL}
    element={<ForgotPasswordCheckEmail />}
  />,
  <Route
    key="create-new-password"
    path={ROUTES.CREATE_NEW_PASSWORD}
    element={
      <PublicRoute>
        <CreateNewPassword />
      </PublicRoute>
    }
  />,
  <Route
    key="reset-password"
    path={ROUTES.RESET_PASSWORD}
    element={
      <PublicRoute>
        <ResetPassword />
      </PublicRoute>
    }
  />,
];
